import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import './time_picker.scss';
import { getActiveLanguage } from '@haldor/ui';
var TimePicker = /*#__PURE__*/function (_Component) {
  function TimePicker(props) {
    var _this;
    _classCallCheck(this, TimePicker);
    _this = _callSuper(this, TimePicker, [props]);
    _defineProperty(_this, "onMinutesFocus", function () {
      _this.refs['minute'].select();
    });
    _defineProperty(_this, "onHourFocus", function () {
      _this.refs['hour'].select();
    });
    _defineProperty(_this, "onInputChange", function (event) {
      var timeString = event.target.value;
      var split = timeString.split(':');
      if (split.length === 2 && _this.props.time) {
        var newTime = Moment(_this.props.time).set('hour', split[0]).set('minute', split[1]);
        _this.props.onChange(newTime);
      }
    });
    _defineProperty(_this, "onHourChange", function (event) {
      var hours = event.target.value;
      if (parseInt(hours) < 0) {
        hours = 0;
      }
      if (parseInt(hours) > 23) {
        hours = 23;
      }
      if (hours.length > 1) {
        _this.refs['minute'].focus();
      }
      if (parseInt(hours) < 10) {
        hours = '0' + hours;
      }
      var newTime = Moment(_this.props.time).set('hour', hours);
      _this.props.onChange(newTime);
    });
    _defineProperty(_this, "onMinutesChange", function (event) {
      var minutes = event.target.value;
      if (minutes.length == 3) {
        event.target.select();
      }
      if (parseInt(minutes) < 0) {
        minutes = 0;
      }
      if (parseInt(minutes) > 59) {
        minutes = 59;
      }
      if (parseInt(minutes) < 10) {
        minutes = '0' + minutes;
      }
      var newTime = Moment(_this.props.time).set('minutes', minutes);
      _this.props.onChange(newTime);
    });
    _defineProperty(_this, "toggleAmPm", function () {
      var newTime = null;
      if (Moment(_this.props.time).format('A') == 'AM') {
        newTime = Moment(_this.props.time).add(12, 'hours');
      } else {
        newTime = Moment(_this.props.time).subtract(12, 'hours');
      }
      _this.props.onChange(newTime);
    });
    Moment.locale(getActiveLanguage());
    return _this;
  }
  _inherits(TimePicker, _Component);
  return _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var format = this.props.twelve ? 'hh' : 'HH';
      var hours = this.props.time ? Moment(this.props.time).format(format) : Moment().format(format);
      var minutes = this.props.time ? Moment(this.props.time).format('mm') : Moment().format('mm');
      return /*#__PURE__*/React.createElement("div", {
        className: "time-picker form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time-picker-container"
      }, /*#__PURE__*/React.createElement("input", {
        className: "time-part",
        type: "tel",
        onChange: this.onHourChange,
        onFocus: this.onHourFocus,
        value: hours,
        ref: "hour"
      }), /*#__PURE__*/React.createElement("span", null, ":"), /*#__PURE__*/React.createElement("input", {
        className: "time-part",
        type: "tel",
        onChange: this.onMinutesChange,
        onFocus: this.onMinutesFocus,
        value: minutes,
        ref: "minute"
      }), this.props.twelve ? /*#__PURE__*/React.createElement("span", {
        className: "time-switcher",
        onClick: this.toggleAmPm
      }, Moment(this.props.time).format('A')) : null));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, {})(TimePicker);